<mat-card class="card">
  <mat-card-content>
    <mat-progress-bar
      *ngIf="isFormLoading"
      mode="indeterminate"
    ></mat-progress-bar>

    <form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
      <ix-fieldset [title]="'General Options' | translate">
        <ix-checkbox
          [formControlName]="intdesc.fcName | translate"
          [label]="intdesc.label | translate"
          [tooltip]="intdesc.tooltip | translate"
        ></ix-checkbox>

        <ix-combobox
          [formControlName]="country.fcName | translate"
          [label]="country.label | translate"
          [tooltip]="country.tooltip | translate"
          [provider]="locationProvider"
        ></ix-combobox>

        <ix-input
          [formControlName]="location.fcName | translate"
          [label]="location.label | translate"
          [tooltip]="location.tooltip | translate"
        ></ix-input>
      </ix-fieldset>

      <div class="form-actions">
        <button
          mat-button
          type="submit"
          color="primary"
          ixTest="save"
          [disabled]="form.invalid || isFormLoading"
        >
          {{ 'Save' | translate }}
        </button>

        <button mat-button type="button" ixTest="cancel" [routerLink]="['/services']">
          {{ 'Cancel' | translate }}
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
